import { render } from "./Avatar.vue?vue&type=template&id=0217d68f"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\someO\\Desktop\\Development\\ClinicalNutritionAcademy\\front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__